<template>
  <div class="baseinfo">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="140"
    >
      <Row>
        <FormItem label="优惠券名称：" prop="rule" style="width: 50%">
          <Input
            v-model="formValidate.couponName"
            type="text"
            placeholder="请输入优惠券名称,最多10个字"
            :maxlength="10"
            style="width: 300px"
            clearable
          >
          </Input>
        </FormItem>
        <FormItem label="优惠券适用平台：" prop="rule" style="width: 50%">
          <Select
            v-model="formValidate.platType"
            placeholder="请选择适用平台"
            style="width: 300px"
            :disabled="details != null"
          >
            <Option value="1">{{ projectName }}</Option>
          </Select></FormItem>
      </Row>
      <Row>
        <FormItem label="适用学校：" prop="rule" style="width: 50%">
          <!-- <Button type="primary" icon="md-add" ghost>请选择学校</Button> -->

          <p v-if="details || portOrg == 2">
            {{ formValidate.schoolName }}
          </p>
          <ChooseSchoolForForm
            v-if="!details && portOrg != 2"
            v-model="selectSchoolData"
            @postSchoolRow="getSelectSchoolRow"
          ></ChooseSchoolForForm>
        </FormItem>
        <FormItem label="适用学期：" prop="rule" style="width: 50%">
          <div style="width: 300px">
            <CascaderYearTerms
              ref="cascaderYearTerms"
              :disabled-year-term="details != null"
              :cache-year-terms="cacheYearTerms"
              :placeholder="`请选择学期`"
              @on-change="onCascaderChange"
            ></CascaderYearTerms>
          </div>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="课程商品分类：" prop="rule" style="width: 50%">
          <Select
            v-model="formValidate.courseType"
            placeholder="请选择课程商品分类"
            style="width: 300px"
            :disabled="details != null"
          >
            <Option
              v-for="item in courseTypeList"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select></FormItem>
        <FormItem label="发行量：" prop="rule" style="width: 50%">
          <InputNumber
            v-model="formValidate.couponQty"
            style="width: 300px"
            :max="9999"
            :min="1"
            placeholder="请输入发行量，最大9999"
          ></InputNumber>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="适用课程：" prop="rule">
          <div class="flex align-items">
            <RadioGroup v-model="formValidate.appScopeType">
              <Radio label="0">全部课程</Radio>
              <Radio label="1">指定课程</Radio>
            </RadioGroup>

            <div class="course-name">
              <p>{{ courseStr }}</p>
              <Button
                class="btn"
                type="primary"
                size="small"
                :disabled="formValidate.appScopeType == 0"
                @click="handleOpenCourse"
              >选择</Button>
            </div>
          </div>
        </FormItem>
      </Row>
    </Form>
    <ChooseCourse
      ref="chooseCourseRef"
      :school-id="formValidate.schoolId"
      :year-terms="[formValidate.yearCode, formValidate.termCode]"
      :class-type="formValidate.courseType"
      :year-term-str="yearTermStr"
      @on-finish="onChooseCourseFinish"
    ></ChooseCourse>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChooseSchoolForForm from '@c/searchBlock/ChooseSchoolForForm';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import ChooseCourse from './ChooseCourse.vue';
export default {
  name: 'BaseInfo',
  components: {
    ChooseSchoolForForm,
    CascaderYearTerms,
    ChooseCourse
  },
  props: {
    details: {
      type: Object,
      default: null
    }
  },
  data() {
    const validateRule = (rule, value, callback) => {
      callback();
    };
    return {
      portOrg: localStorage.getItem('portOrg'),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      courseTypeList: [
        {
          name: '素质课',
          id: 1
        },
        {
          name: '基础托管',
          id: 2
        }
      ], // 课程类别
      yearTermStr: '',
      formValidate: {
        appScopeType: '1',
        couponName: '',
        platType: '1',
        couponQty: null,
        schoolId: '',
        schoolName: '',
        yearCode: '',
        termCode: '',
        courseType: null,
        courseList: [],
        appScope: false,
        scopeGoodsIds: []
      },
      ruleValidate: {
        rule: [
          { required: true, validator: validateRule, trigger: 'blur' }
        ]
      },
      selectSchoolData: {}, // 选择到的学校数据
      cacheYearTerms: []

    };
  },
  computed: {
    ...mapState(['projectName']),
    courseStr() {
      return this.formValidate.courseList.map(item => { return item.classroomName; }).join('、');
    }
  },
  watch: {
    details(newVal) {
      this.fillForm(newVal);
    }
  },
  created() {
    if (this.portOrg == 2) {
      this.formValidate.schoolId = this.userInfo.orgId;
      this.formValidate.schoolName = this.userInfo.orgName;
    }
  },
  methods: {
    // 编辑回填
    fillForm(info) {
      for (const k in this.formValidate) {
        this.formValidate[k] = info[k] ? info[k] : this.formValidate[k];
        if (['platType'].includes(k)) {
          this.formValidate[k] = String(info[k]);
        }
        if (['appScope'].includes(k)) {
          this.formValidate[k] = info[k] == 0;
        }
        if (this.formValidate.appScope) {
          this.formValidate.courseList = [];
          this.formValidate.appScopeType = '0';
        } else {
          this.formValidate.appScopeType = '1';
        }
      }
      this.cacheYearTerms = [info.yearCode, String(info.termCode)];
      setTimeout(() => {
        this.$refs.cascaderYearTerms.setYearTerms([info.yearCode, String(info.termCode)]);
      }, 300);
    },
    checkForm() {
      const { couponName, platType, yearCode, termCode, schoolId, schoolName, courseType, couponQty, appScope, appScopeType, courseList } = this.formValidate;
      if (!couponName) {
        this.$Message.warning('请输入优惠券名称');
        return false;
      }
      if (!schoolName) {
        this.$Message.warning('请选择学校');
        return false;
      }
      if (!schoolId) {
        this.$Message.warning('请选择学期');
        return false;
      }
      if (!courseType) {
        this.$Message.warning('请选择课程商品分类');
        return false;
      }
      if (!couponQty) {
        this.$Message.warning('请输入发行量');
        return false;
      }
      if (appScopeType == 1 && courseList.length == 0) {
        this.$Message.warning('请选择适用课程');
        return false;
      }
      return true;
    },
    getSelectSchoolRow(row) {
      this.formValidate.schoolId = row.orgId;
      this.formValidate.schoolName = row.name;
      this.selectSchoolData = row;
      //  this.$refs.formValidate.validateField('schoolId');
      console.log(this.formValidate);
    },
    onCascaderChange(v) {
      this.formValidate.yearCode = v[0];
      this.formValidate.termCode = v[1];
      this.$nextTick(() => {
        this.yearTermStr = this.$refs.cascaderYearTerms.getObjResult().yearTermStr;
      });
    },
    onChooseCourseFinish(data) {
      this.formValidate.courseList = data;
    },
    // 选择课程
    handleOpenCourse() {
      if (!this.formValidate.schoolName) {
        return this.$Message.error('请先选择学校！');
      }
      if (!this.formValidate.yearCode) {
        return this.$Message.error('请先选择学期！');
      }
      if (!this.formValidate.courseType) {
        return this.$Message.error('请先课程商品分类！');
      }

      this.$refs.chooseCourseRef.open(this.formValidate.courseList);
    },
    // 获取参数
    async getParameter() {
      return new Promise(async(resolve, reject) => {
        const { couponName, platType, yearCode, termCode, schoolId, schoolName, courseType, couponQty, appScope, appScopeType } = this.formValidate;
        let scopeGoodsIds = [];
        if (appScopeType == 1) {
          scopeGoodsIds = this.formValidate.courseList.map(item => { return item.classroomId; });
        }
        resolve({
          couponName, platType, yearCode, termCode, schoolId, schoolName, courseType, couponQty, appScope: appScopeType, scopeGoodsIds
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.baseinfo {
  margin-bottom: 16px;
}
.course-name {
  position: relative;
  border: 1px solid #eee;
  border-radius: 6px 0 0 6px;
  width: 300px;
  height: 26px;
  line-height: 26px;

  > p {
    color: #ccc;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
  }

  .btn {
    position: absolute;
    right: -44px;
    top: 0;
  }
  .checkbox {
    position: absolute;
    right: -114px;
    top: 0;
  }
}
</style>
